import React,{ useState, useEffect } from 'react';
import {
    Modal
} from 'antd';

import ModemUpgradeMenu from './support/ModemUpgradeMenu';
import ModemUpgradeInstructions from './support/ModemUpgradeInstructions';
import ModemUpgradeTroubleshooting from './support/ModemUpgradeTroubleshooting';
import ModemUpgradeBenefits from './support/ModemUpgradeBenefits';

import MacImage1 from '../images/modem-swap/mac-address-location-fig1.png';
import MacImage2 from '../images/modem-swap/mac-address-location-fig2.png';
import ModemSyncImage1 from '../images/modem-swap/modem-sync-fig1.png';
import ModemSyncImage2 from '../images/modem-swap/modem-sync-fig2.png';

function ModemUpgrades() {
    const [ activeComponent, setActiveComponent ] = useState( [] );
    const [ defaultOpenKeys, setDefaultOpenKeys ] = useState( ['sub1'] );
    const [ defaultSelectedKeys, setDefaultSelectedKeys ] = useState( ['sub1', 'upgrade-benefits'] );
    const [modalOpen, setModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    
    useEffect(() => {
        const url_string = window.location.href;
        let url = new URL(url_string);
        const upgradeType = url.searchParams.get("modem-upgrade");
    
        console.log( "upgradeType: ", upgradeType );

        switch( upgradeType ) {
            case 'instructions':
            setActiveComponent( 
                <ModemUpgradeInstructions 
                    handleOpenQuestionModal={ handleOpenQuestionModal }
                    handleOpenQuestionModalSync={ handleOpenQuestionModalSync }
                /> );
            setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'upgrade-instructions'] );
            break;
            case 'troubleshooting':
            setActiveComponent( <ModemUpgradeTroubleshooting /> );
            setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'upgrade-troubleshooting'] );
            break;
            case 'benefits':
            setActiveComponent( <ModemUpgradeBenefits /> );
            setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'upgrade-benefits'] );
            break;
            default:
            setActiveComponent( 
                <ModemUpgradeInstructions 
                    handleOpenQuestionModal={ handleOpenQuestionModal }
                    handleOpenQuestionModalSync={ handleOpenQuestionModalSync }
                />
            );
            setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'upgrade-instructions'] );
            break;
        } 
    
    }, [setDefaultOpenKeys]);
    
    const handleMenuItemClick = ( e ) => {
        let componentToRender = <></>;

        switch( e.key ) {
            case 'upgrade-instructions':
            componentToRender = 
            <ModemUpgradeInstructions 
                handleOpenQuestionModal={ handleOpenQuestionModal }
                handleOpenQuestionModalSync={ handleOpenQuestionModalSync }
            />;
            setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'upgrade-instructions'] );
            break;

            case 'upgrade-troubleshooting':
            componentToRender = <ModemUpgradeTroubleshooting />;
            setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'upgrade-troubleshooting'] );
            break;

            case 'upgrade-benefits':
            componentToRender = <ModemUpgradeBenefits />;
            setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'upgrade-benefits'] );
            break;

            default:
            componentToRender = 
            <ModemUpgradeInstructions 
                handleOpenQuestionModal={ handleOpenQuestionModal }
                handleOpenQuestionModalSync={ handleOpenQuestionModalSync }
            />;
            setDefaultOpenKeys( ['sub1'] );
            setDefaultSelectedKeys( ['sub1', 'upgrade-instructions'] );
        }

        setActiveComponent( componentToRender );
    }

    const handleOpenQuestionModal = () => {
        setModalOpen( true );
        setModalTitle("Where's my MAC address?");
        setModalContent(
            <div className='channel-modal-content'>
                <div className='channel-modal-img-container' >
                    <img style={{padding:'1rem'}} src={ MacImage1 } />
                    <img style={{padding:'1rem'}} src={ MacImage2 } />
                </div>
                <div style={{marginTop:'1.5rem'}}>
                    <p>Your MAC address can usually be found on the back (or bottom) of your modem, on or near a barcoded sticker.</p>
                </div>
            </div>
        );
    }

    const handleOpenQuestionModalSync = () => {
        setModalOpen( true );
        setModalTitle("How do I know if i'm synced?");
        setModalContent(
            <div className='channel-modal-content'>
                <div className='channel-modal-img-container' >
                    <img style={{padding:'1rem'}} src={ ModemSyncImage1 } />
                    <p><b>Hitron CODA56 </b>Full synch status of the modem, highlighting (with a red box) the lights that should be green, prior to reconnecting your router.</p>
                    <img style={{padding:'1rem'}} src={ ModemSyncImage2 } />
                    <p><b>Sercomm DM1000 </b>Full synch status of the modem, highlighting (with a red box) the lights that should be green, prior to reconnecting your router.</p>
                </div>
            </div>
        );
    }

    const handleCloseModal = () => {
        setModalOpen( false );
    }

    return (
        <div id="react-hardware-setup-component">
            <div className="sidebar-menu-desktop">
                <ModemUpgradeMenu 
                    handleMenuItemClick={ handleMenuItemClick }
                    openKeys={ defaultOpenKeys }
                    selectedKeys={ defaultSelectedKeys }
                />
            </div>
            <div className='content-container'>
                { activeComponent }
            </div>
            <Modal
                title={ modalTitle }
                centered
                open={ modalOpen }
                footer={[]}
                onCancel={ handleCloseModal }
                width={ 600 }
            >   
                { modalContent }
            </Modal>
        </div>
    )
}

export default ModemUpgrades